export default "__VITE_ASSET__2e37d418__"